// material ui
import { MenuItem, IconButton, Menu, Typography, Box, Stack, Divider, Tooltip, Alert, Icon, Link } from "@mui/material"

import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
//slices
import { getMensagensWhatsappDb } from 'src/redux/slices/chat'
//utils
import { soNumeros, verifyRules } from '../../../../../../utils/functions';
import { AlertDialogLoading } from "../AlertDialogLoading";
import AudioComponent from "../AudioComponent";
import LocationPreview from "../LocationPreview";
import MarkdownWrapper from './MarkdownWrapper';
import { QuotedMessage } from "./QuotedMessage";
import { ReferralCard } from "./ReferralCard";
import {
  ChatLayout,
  ImageContainer,
  ImageContainerReply,
  MessageContent,
  MessageContentText,
  StickerComponent,
} from "./style";
import useAuth from "src/hooks/useAuth";
import { downloadFromBase64 } from "src/utils/helpers";
import Iconify from "src/components/Iconify";
import { useSnackbar } from "notistack";
import SkeletonChatImage from "src/components/skeleton/chats/SkeletonChatImage";
import moment from "moment";
const defaultImage = "https://zapchat.nyc3.digitaloceanspaces.com/images/not-picture.png";

import { Button } from "src/@/components/ui/button";
import { Progress } from "src/@/components/ui/progress";

//actions
import v1_actionDownloadMediaWhatsapp from "src/actions/v1/whatsapp/v1_actionDownloadMediaWhatsapp";
import v1_actionDeletarMensagemWhatsapp from "src/actions/v1/whatsapp/v1_actionDeletarMensagemWhatsapp";
import v1_actionEncaminharMensagemWhatsapp from "src/actions/v1/whatsapp/v1_actionEncaminharMensagemWhatsapp";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "src/@/components/ui/dropdown-menu"
import Scrollbar from "src/components/Scrollbar";
import { ZuiTooltip } from "src/@/components/use/tooltip";
import { base64ToBlob, getImageBlob, initCacheFileSave } from "src/helpers/cache.helper";
import ModalMultiContact from "src/components/_chats/ModalMultiContact";
import Vcard from "src/components/_chats/Vcard";
import { Card, CardContent } from "src/@/components/ui/card";
import { ButtonLoading } from "src/@/components/use/ButtonLoading";
import { Badge } from "src/@/components/ui/badge";
import { getAudioFromCache } from 'src/helpers/audio.helper';
import ModalEncaminharMsg from "src/sections/@chats/chat/ChatComponent/ModalEncaminharMsg";
import TemplateMessage from "./TemplateMessage";
const mimeTypesImages = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/webp"];

const ChatComponent = ({
  message,
  config,
  chat,
  isMe,
  isWarning,
  selectMessageId,
  selectMessageResponder,
  callbackGpt,
  isDesktop,
  key,
  onCallbakOpenModal,
  onDeleteNote,
  isReply,
  resendMsg,
  onResendAudio,
  onDeleteMsgAudioResend,
  loadingResend,
  loadingResendAudio
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { user, cliente } = useAuth()
  const { t } = useTranslation('chat');
  const imageRef = useRef(null);
  const audioRef = useRef(null);
  // Midia de pagina Meta (Instagram/Messenger): renderiza direto da URL de CDN.
  // WhatsApp nao tem isMetaMedia, entao inicializa null como antes (comportamento intocado).
  const isMetaAudio = message.isMetaMedia && (message.type === 'ptt' || message.type === 'audio');
  const [audioUrl, setAudioUrl] = useState(() => (isMetaAudio ? message.mediaUrl : null));
  const [display, setDisplay] = useState("block");
  const [openModalImage, setOpenModalImage] = useState(false);
  const textRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openEncaminharDialog, setOpenEncaminharDialog] = useState(false);
  const [loadingDeletarMensagem, setLoadingDeletarMensagem] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingDownloadVideo, setLoadingDownloadVideo] = useState(false);
  const [loadingDownloadVideoId, setLoadingDownloadVideoId] = useState(null);
  const [isDownloadImage, setIsDownloadImage] = useState(false);
  const [downloaded, setDownloaded] = useState(() => !!message.isMetaMedia);
  const typesIgnore = ["notification_template", "e2e_notification", "call_log", "gp2"];
  const [openMenu, setOpenMenuActions] = useState(null);
  const [loadingEncaminharMensagem, setLoadingEncaminharMensagem] = useState(null);
  const [blobUrl, setBlobUrl] = useState(() => (message.isMetaMedia && !isMetaAudio ? message.mediaUrl : null));
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [progressValue, setProgressValue] = useState(0);

  const platform = message.platform || 'whatsapp';




  const handleResendClick = async () => {
    if (isButtonDisabled) return;

    setIsButtonDisabled(true);
    try {
      if (message.type === 'ptt' || message.type === 'audio') {
        await onResendAudio(message.id);
      } else {
        await resendMsg(message);
      }
    } finally {
      // Reabilita quando a requisição termina, não por timer: o debounce de 1s
      // liberava o botão no meio de um envio lento e o clique seguinte mandava
      // uma segunda cópia da mensagem ao cliente.
      setIsButtonDisabled(false);
    }
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function validaChatId(val) {
    if (typeof val.chatId === 'string') {
      return soNumeros(val.chatId);
    } else {
      return val.chatId.user;
    }
  }

  const getCacheBlob = async (id, message) => {
    const response = await getImageBlob(id);
    if (!response) return;
    if (message.type === "image" || message.type === "sticker") {
      setBlobUrl(response)
    } else if (message.type === "audio" || message.type === "ptt") {
      setAudioUrl(response)
      setDownloaded(true);
    } else if (message.type === "video") {
      setBlobUrl(response)
      setDownloaded(true);
    }

  }

  useEffect(() => {
    if (blobUrl) return;
    // Midia Meta (Instagram/Messenger) resolve pela URL de CDN, nao pelo cache/download do WhatsApp.
    if (message.isMetaMedia) return;
    getCacheBlob(message.id, message);
  }, [])

  useEffect(() => {
    if (message.type === "sticker" && !message.preSend && !blobUrl) {
      onClickDownload("sticker");
    }
  }, [message.id])

  // Animação do progresso para componentes de loading
  useEffect(() => {
    if (message.preSend || (loadingDownloadVideo && message.id === loadingDownloadVideoId)) {
      const interval = setInterval(() => {
        setProgressValue(prev => {
          if (prev >= 90) return prev;
          return prev + Math.random() * 15;
        });
      }, 500);

      return () => clearInterval(interval);
    } else {
      setProgressValue(0);
    }
  }, [message.preSend, loadingDownloadVideo, loadingDownloadVideoId, message.id]);

  // Placeholder unico para midia em transito (enviando/baixando) — antes eram
  // quatro blocos identicos espalhados por validaMediaMessage.
  const SendingPlaceholder = ({ icon, label, tall }) => (
    <div className={`w-[220px] ${tall ? 'h-[170px]' : 'h-[86px]'} flex items-center justify-center rounded-xl bg-black/[0.03] dark:bg-white/[0.04] border border-black/5 dark:border-white/10`}>
      <div className="flex flex-col items-center gap-2.5 px-4">
        <div className="flex items-center gap-2">
          <Iconify icon={icon} className="w-4 h-4 text-[#7C3AED] animate-pulse" />
          <p className="text-xs italic text-muted-foreground">{label}</p>
        </div>
        <Progress value={progressValue} className="h-1.5 w-32" />
      </div>
    </div>
  );

  const excluirMensagem = async (message) => {
    try {
      const querys = `?sessao=${chat.sessao}&canal=${chat?.canal}`;
      let data = { phone: validaChatId(message), messageId: message.id }
      await v1_actionDeletarMensagemWhatsapp(querys, data)
      dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
    } catch (error) {
      console.log('Erro ao apagar mensagem do Chat', error)
      throw error;
    }
  };

  async function encaminharMesagemWhatsapp(phone) {
    try {
      setLoadingEncaminharMensagem(true);
      let data = {
        phone: phone,
        messageId: message.id
      };
      const querys = `?sessao=${chat.sessao}&canal=${platform}`;
      await v1_actionEncaminharMensagemWhatsapp(querys, data);
      setLoadingEncaminharMensagem(false);
      setOpenEncaminharDialog(false)

      enqueueSnackbar(t('forward.success'), { variant: 'success' });

    } catch (error) {
      enqueueSnackbar(t('forward.error'), { variant: 'error' });
      setLoadingEncaminharMensagem(false);
      console.log(error);
    }
  }

  async function baixarMidiaDevice() {
    let querys = `?sessao=${chat.sessao}&msgId=${message.id}&canal=${platform}`
    const response = await v1_actionDownloadMediaWhatsapp(querys);
    const a = document.createElement("a");
    a.href = `data:${message.mimetype};base64, ${response.data.data.base64}`;
    a.download = `lais_file-${moment(new Date()).format("YYYY-MM-DD:HH:mm")}`;
    a.click();
    ///downloadFromBase64(response.data.data.base64, `lais_${(new Date).toISOString()}`, validaAudio())
  }

  async function baixarAudioDevice() {
    function validaAudio() {
      if (message.type === "audio" || message.type === "ptt") {
        return 'audio/mp3';
      } else {
        return message.mimetype;
      }
    }
    let querys = `?sessao=${chat.sessao}&msgId=${message.id}&canal=${platform}`
    const response = await v1_actionDownloadMediaWhatsapp(querys);
    downloadFromBase64(response.data.data.base64, `lais_file-${moment(new Date()).format("YYYY-MM-DD:HH:mm")}`, validaAudio())
  }


  const onClickDownload = async (type, option) => {
    const checkBlob = await getImageBlob(message.id);
    if (checkBlob) {
      if (type === "image") {
        imageRef.current.src = checkBlob;
        setIsDownloadImage(true);
        setDisplay("none");
      } else if (type === "sticker") {
        setBlobUrl(checkBlob);
      } else if (type === "audio") {
        setAudioUrl(checkBlob);
      }
      return true;
    }
    // Midia de pagina Meta (Instagram/Messenger) ja esta re-hospedada no S3 e vem com a
    // URL pronta em mediaUrl. O endpoint de download le a collection do WhatsApp, onde
    // essas mensagens nao existem — chamar de la so gera erro e o arquivo nunca abre.
    if (message.isMetaMedia && message.mediaUrl) {
      if (type === "document") {
        const a = document.createElement("a");
        a.href = message.mediaUrl;
        a.download = option?.filename || '';
        a.target = "_blank";
        a.rel = "noopener";
        a.click();
      } else if (type === "image") {
        imageRef.current.src = message.mediaUrl;
        setIsDownloadImage(true);
        setDisplay("none");
      } else if (type === "sticker" || type === "video") {
        setBlobUrl(message.mediaUrl);
        setDownloaded(true);
      } else if (type === "audio" || type === "ptt") {
        setAudioUrl(message.mediaUrl);
        setDownloaded(true);
      }
      return true;
    }

    try {
      setLoadingDownload(true)

      if (type === "video") {
        setLoadingDownloadVideo(true)
        setLoadingDownloadVideoId(message.id)
      }
      let querys = `?sessao=${chat.sessao}&msgId=${message.id}&canal=${platform}`
      const response = await v1_actionDownloadMediaWhatsapp(querys);
      if (type === "video" && response.data.status === "error") {
        setLoadingDownloadVideo(false)
        setLoadingDownloadVideoId(null);
        enqueueSnackbar(t('messageList.mediaDownloadFailed'), { variant: 'error' });
      }
      setLoadingDownloadVideo(false)
      setLoadingDownloadVideoId(null)
      setLoadingDownload(false)

      if (type === "image") {
        initCacheFileSave(message.id, `data:image/jpeg;base64, ${response.data.data.base64}`, message.mimetype);
        console.log('cache salvo', message.id, `data:image/jpeg;base64, ${response.data.data.base64}`, message.mimetype)
        imageRef.current.src = `data:image/jpeg;base64, ${response.data.data.base64}`;
        setIsDownloadImage(true);
        setDisplay("none");
        setLoadingDownload(false)
      } else if (type === "sticker") {
        const dataUrl = `data:${message.mimetype || 'image/webp'};base64, ${response.data.data.base64}`;
        initCacheFileSave(message.id, dataUrl, message.mimetype);
        setBlobUrl(dataUrl);
        setLoadingDownload(false)
      } else if (type === "video") {
        initCacheFileSave(message.id, `data:video/webm;base64, ${response.data.data.base64}`, message.mimetype);

        imageRef.current.src = `data:video/webm;base64, ${response.data.data.base64}`;
        setDisplay("none");
        setDownloaded(true);
      } else if (type === "ptt") {
        initCacheFileSave(message.id, `data:audio/ogg;base64, ${response.data.data.base64}`, message.mimetype);
        setAudioUrl(`data:audio/ogg;base64, ${response.data.data.base64}`);
        setDownloaded(true);
      } else if (type === "audio") {
        initCacheFileSave(message.id, `data:audio/ogg;base64, ${response.data.data.base64}`, message.mimetype);
        setDownloaded(true);
        setAudioUrl(`data:audio/ogg;base64, ${response.data.data.base64}`);
      } else if (type === "document") {
        const a = document.createElement("a");
        a.href = `data:${option.mimetype};base64, ${response.data.data.base64}`;
        a.download = `${option.filename}`;
        a.click();
      }
      return true;
    } catch (error) {
      console.log('erro ao baixar mídia', error)

      setLoadingDownloadVideo(null)
      setLoadingDownloadVideoId(false);
      setLoadingDownload(false)
      enqueueSnackbar(t('messageList.downloadFailed'), { variant: 'error' });
    }
  };


  const handleOnOpenModalImage = async () => {
    if (isDownloadImage) {
      onCallbakOpenModal(imageRef.current.src);
    } else {
      const response_download = await onClickDownload("image");
      if (response_download) onCallbakOpenModal(imageRef.current.src);

    }
  };


  // Status de entrega no padrao WhatsApp: relogio (enviando), check unico
  // (servidor), check duplo cinza (entregue), check duplo azul (lido).
  function renderAckIcon(m) {
    if (m.preSend) return <Iconify icon="mdi:clock-outline" width={12} className="text-gray-400 dark:text-white/40" />;
    if (m.ack === -1) return <Iconify icon="ix:error-filled" width={12} className="text-red-500" />;
    if (m.ack === 3 || m.ack === 4) return <Iconify icon="ri:check-double-fill" width={14} className="text-[#53bdeb]" />;
    if (m.ack === 2) return <Iconify icon="ri:check-double-fill" width={14} className="text-gray-400 dark:text-white/40" />;
    if (m.ack === 1 || m.self === "out") return <Iconify icon="material-symbols:check" width={14} className="text-gray-400 dark:text-white/40" />;
    return null;
  }

  // Hora compacta (HH:MM); a data completa fica no tooltip — o feed ja tem
  // separadores por dia, repetir a data em cada balao era so ruido.
  function getMessageTime(m) {
    const date = new Date(m.timestamp * 1000);
    const lang = navigator.language || navigator.languages[0];
    const fullDateTime = `${date.toLocaleDateString(lang, { day: "numeric", month: "numeric", year: "numeric" })} ${date.toLocaleTimeString(lang)}`;
    const time = date.toLocaleTimeString(lang, { hour: "2-digit", minute: "2-digit" });
    return (
      <span
        title={fullDateTime}
        className="inline-flex items-center gap-[3px] text-[10px] leading-none text-gray-500/90 dark:text-white/50 select-none whitespace-nowrap"
      >
        {time}
        {isMe === "right" && renderAckIcon(m)}
      </span>
    );
  }

  function getSenderDisplayName() {
    const sender = message?.sender;
    return (
      sender?.formattedName ||
      sender?.pushName ||
      sender?.name ||
      sender?.verifiedName ||
      chat?.nomeCliente ||
      ''
    );
  }

  function getSender(m) {
    let sender = m?.sender?.id?.user;
    if (m.sender) {
      const key = [
        "name",
        "shortName",
        "pushname",
        "verifiedName",
        "formattedName",
      ].find((n) => {
        if (n in m.sender && !!String(m.sender[n]).trim()) {
          return m.sender[n];
        }
      });
      sender = m.sender[key];
    }
    return sender;
  }

  function getReason(m) {
    try {
      const sender = getSender(m);
      if (m.type === "sticker") return t('messageList.senderSentSticker', { sender });
      // if (m.type === "location") return `${sender} enviou uma localização`;
      if (m.type === "revoked") return t('messageList.senderDeletedMessage', { sender });
      if (m.type === "gp2") {
        let users = [];
        if (m.recipients && Array.isArray(m.recipients)) {
          users = m.recipients.reduce(
            (c, acc, i) => c + (i > 0 ? ", " : "") + acc.user,
            ""
          );
        }
        if (m.subtype === "leave") return t('messageList.userLeft', { user: m?.recipients[0]?.user });
        if (m.subtype === "remove") return t('messageList.senderRemoved', { sender, users });
        if (m.subtype === "add") return t('messageList.senderAdded', { sender, users });
      }
    } catch (error) {
      return <p>{t('common:status.error')}</p>;
    }
  }



  const validaMediaMessage = (message) => {

    if (message.type === 'location') {
      return (
        <LocationPreview
          base64={`data:image/jpg;base64, ${message.body}`}
          link={`https://www.google.com/maps/place/${message.lat},${message.lng}`}
        />
      )
    }

    if (message.type === "ptt") {
      if (message.preSend) {
        return <SendingPlaceholder icon="solar:soundwave-bold" label={t('media.sendingAudio')} />;
      } else if (message.type === "revoked") {
        return (
          <Box>
            <Typography sx={{ mb: 2, fontSize: 12, fontStyle: 'italic' }}>{t('media.voiceDeleted')}</Typography>
          </Box>
        )
      } else {
        return (
          <div className="w-[260px] max-w-full">
            <AudioComponent
              downloaded={downloaded}
              url={audioUrl}
              loading={loadingDownload}
              isMe={message.fromMe}
              remoteSource={!!message.isMetaMedia}
              profileImage={!message?.sender?.profilePicThumbObj?.eurl ? defaultImage : message?.sender?.profilePicThumbObj?.eurl}
              audioRef={audioRef}
              downloadAudio={onClickDownload}
              id={message.id}
            />

            {message?.transcribeAudio && (
              <p className="text-[12px] italic mt-1.5 mx-1 pt-1.5 pb-0.5 leading-snug text-gray-600 dark:text-white/70 border-t border-black/5 dark:border-white/10">
                {message?.transcribeAudio}
              </p>
            )}
          </div>

        )
      }



    } else if (message.type === "audio") {
      if (message.preSend) {
        return <SendingPlaceholder icon="solar:soundwave-bold" label={t('media.sendingAudio')} />;
      } else if (message.type === "revoked") {
        return (
          <Box>
            <Typography sx={{ mb: 2, fontSize: 12, fontStyle: 'italic' }}>{t('media.audioDeleted')}</Typography>
          </Box>
        )
      } else {
        return (
          <div className="w-[260px] max-w-full">
            <AudioComponent
              downloaded={downloaded}
              url={audioUrl}
              loading={loadingDownload}
              isMe={message.fromMe}
              remoteSource={!!message.isMetaMedia}
              profileImage={!message?.sender?.profilePicThumbObj?.eurl ? defaultImage : message?.sender?.profilePicThumbObj?.eurl}
              audioRef={audioRef}
              downloadAudio={onClickDownload}
              id={message.id}
            />

            {message?.transcribeAudio && (
              <p className="text-[12px] italic mt-1.5 mx-1 pt-1.5 pb-0.5 leading-snug text-gray-600 dark:text-white/70 border-t border-black/5 dark:border-white/10">
                {message?.transcribeAudio}
              </p>
            )}

          </div>

        )
      }


    } else if (message.type === "video") {
      if (message.preSend) {
        return <SendingPlaceholder icon="solar:video-library-bold" label={t('media.sendingVideo')} tall />;
      } else if (loadingDownloadVideo && message.id === loadingDownloadVideoId) {
        return <SendingPlaceholder icon="solar:download-bold" label={t('media.downloadingVideo')} tall />;
      } else {
        if (message.type === "revoked") {
          return (
            <Box>
              <Typography sx={{ mb: 2, fontSize: 12, fontStyle: 'italic' }}>{t('media.videoDeleted')}</Typography>
            </Box>
          )
        } else {
          return (
            <ImageContainer>
              <>
                <video
                  ref={imageRef && imageRef}
                  //src={`data:image/png;base64, ${message.body}`}
                  src={blobUrl ? blobUrl : `data:video/webm;base64, ${message.body}`}
                  controls
                  // Some o botao de fullscreen NATIVO dos controles (Chrome/Edge —
                  // Firefox/Safari nao suportam controlsList e ignoram o atributo).
                  // O fullscreen nativo usa o mesmo CSS do balao pequeno
                  // (object-fit/max-height), que corta um video vertical de story;
                  // o botao de expandir abaixo abre o ModalLightbox, que roda sob
                  // nosso proprio CSS e mostra o quadro inteiro.
                  controlsList="nofullscreen"
                />
                {downloaded && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCallbakOpenModal(blobUrl || message.mediaUrl, 'video');
                    }}
                    className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/50 hover:bg-black/70 backdrop-blur-sm flex items-center justify-center transition-colors z-10"
                    title={t('media.expandVideo', 'Ver em tela cheia')}
                  >
                    <Iconify icon="eva:expand-outline" width={14} className="text-white" />
                  </button>
                )}
                {!downloaded && (
                  <div
                    className="absolute inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm rounded-lg transition-all duration-300 hover:bg-black/60 cursor-pointer group"
                    style={{ display: display }}
                    onClick={() => onClickDownload("video")}
                  >
                    <div className="flex flex-col items-center space-y-3 p-6">
                      <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center group-hover:bg-white/30 transition-all duration-300">
                        <Iconify
                          icon="solar:download-bold"
                          className="w-8 h-8 text-white group-hover:scale-110 transition-transform duration-300"
                        />
                      </div>
                      <div className="text-center">
                        <p className="text-white font-medium text-sm mb-1">{t('media.videoNotDownloaded')}</p>
                        <p className="text-white/80 text-xs">{t('media.clickToDownload')}</p>
                      </div>
                    </div>
                  </div>
                )}

              </>
            </ImageContainer>
          )
        }
      }

    } else if (message.type === "sticker") {
      return (
        <div className="w-[125px] h-[125px] flex items-center justify-center">
          {blobUrl ? (
            <StickerComponent src={blobUrl} alt="sticker" />
          ) : (
            <div className="w-[100px] h-[100px] rounded-lg bg-muted/30 animate-pulse flex items-center justify-center">
              <Iconify icon="solar:sticker-smile-circle-bold" className="w-6 h-6 text-muted-foreground/50" />
            </div>
          )}
        </div>
      )
    } else if (mimeTypesImages.includes(message.mimetype)) {
      if (message.type === "revoked") {
        return (
          <Box>
            <Typography sx={{ mb: 2, fontSize: 12, fontStyle: 'italic' }}>{t('media.imageDeleted')}</Typography>
          </Box>
        )
      } else {
        return (
          isReply ? (
            <ImageContainerReply>
              <img
                style={{ borderRadius: 5, maxHeight: 100, width: '100%' }}
                ref={imageRef}
                src={blobUrl ? blobUrl : `data:image/png;base64, ${message.body}`}
                // loading={"lazy"}
                alt={message.caption}
                onClick={() => {

                  handleOnOpenModalImage()
                }}
              />

            </ImageContainerReply>
          ) : (
            <ImageContainer>
              {/* A imagem fica montada durante o download (overlay por cima, em vez
                  de trocar por skeleton): trocar desmontava o img — o balao w-fit
                  colapsava para a largura minima e o imageRef.current.src atribuido
                  ao fim do download apontava para um no morto. */}
              <>
                <img
                  ref={imageRef}
                  src={blobUrl ? blobUrl : `data:image/png;base64, ${message.body}`}
                  alt={message.caption}
                  onClick={() => {
                    if (loadingDownload) return;
                    handleOnOpenModalImage()
                  }}
                />
                {loadingDownload && (
                  <div className="absolute inset-0 rounded-[10px] bg-black/30 backdrop-blur-[1px] flex items-center justify-center">
                    <Iconify icon="svg-spinners:ring-resize" width={26} className="text-white" />
                  </div>
                )}
              </>
            </ImageContainer>
          )

        )
      }

    }
  }

  function getBodyMessage() {
    if (message.isDeleted) {
      return (
        <span className="italic text-gray-500 dark:text-white/50">
          {t('messageList.messageDeleted')}
        </span>
      );
    }
    // Early return for chat messages with a body
    if (message?.body && (message.type === "chat" || message.type === "automated_greeting_message")) {
      return <MarkdownWrapper>{message.body}</MarkdownWrapper>;
    } else if (message.type === "ciphertext") {
      return (
        <div className="bg-yellow-50 dark:bg-yellow-500/10 border border-yellow-100 dark:border-yellow-500/20 p-2 rounded-sm flex flex-row gap-2 items-center">
          <p className="text-sm text-muted-foreground italic">{t('messageList.waitingMessage')}</p>
          <Button
            onClick={() => {
              window.open('https://faq.whatsapp.com/835452491239734/?helpref=hc_fnav&locale=pt_BR', '_blank')
            }}
            variant="text"
            className="text-black dark:text-white h-5 underline"
          >
            {t('messageList.learnMore')}
          </Button>
        </div>
      )
    }

    // Group conditions for media messages
    const isMediaMessage = message.type === "location" || message.isMedia === false ||
      ['ptt', 'image', 'audio', 'video', 'sticker'].includes(message.type) ||
      message.mimetype === "image/jpeg";

    if (isMediaMessage) {
      return validaMediaMessage(message, isReply);
    }

    // Handle cases without a message body
    if (!message?.body) {
      return getReason(message);
    }
  }


  const LABEL_REPLY = t('messageList.actions.reply');
  const LABEL_FORWARD = t('messageList.actions.forward');
  const optionsPrelude = [];

  // Instagram Login (graph.instagram.com) nao suporta reply_to na Messaging API —
  // so contas ligadas a Pagina Facebook (Messenger Platform) documentam citacao.
  // Receber reply do cliente no webhook continua funcionando; enviar citado, nao.
  const canReplyToMessage = message.platform !== 'instagram';
  if (canReplyToMessage) {
    optionsPrelude.push({
      label: LABEL_REPLY,
      method() {
        setAnchorEl(null);
        selectMessageResponder();
      },
    });
  }

  // Adiciona opção "Apagar" apenas para WhatsApp (Meta nao permite unsend via API)
  if (message.platform === 'whatsapp') {
    optionsPrelude.push({
      label: t('messageList.actions.delete'),
      method() {
        setAnchorEl(null);
        setOpenDeleteDialog(true);
      },
    });
    optionsPrelude.push({
      label: t('messageList.actions.select'),
      method() {
        setAnchorEl(null);
        selectMessageId(message.id);
      },
    });
  }

  const options = chat.statusRoom === "Atendendo" ? optionsPrelude : optionsPrelude.filter(option => option.label !== LABEL_FORWARD && option.label !== LABEL_REPLY);


  if (message.type === "video" || message.type === "image") {
    options.push({
      label: t('messageList.actions.downloadMedia'),
      method() {
        setAnchorEl(null);
        baixarMidiaDevice();
      },
    });
  }



  if (message.type === "ptt" || message.type === "audio") {
    options.push({
      label: t('messageList.actions.downloadAudio'),
      method() {
        setAnchorEl(null);
        baixarAudioDevice();
      },
    });
  }

  let gatilhosCopilot = config?.global.chatgpt_gatilhos;

  if (message.type === "note") {
    return (
      <Stack key={key} direction={'row'}>
        <ChatLayout side={isMe}>
          <Stack sx={{ mt: 3 }}>
            <div
              className={`${isDesktop ? 'w-fit' : 'w-full'} max-w-full min-w-[220px] group/nota relative overflow-hidden rounded-2xl rounded-tr-[4px] bg-amber-50 dark:bg-amber-500/10 border border-amber-200/70 dark:border-amber-500/20 shadow-sm dark:shadow-none`}
            >
              <div className="flex items-center justify-between gap-2 px-2.5 py-1.5 bg-amber-100/70 dark:bg-amber-500/15 border-b border-amber-200/60 dark:border-amber-500/20">
                <div className="flex items-center gap-1.5 min-w-0">
                  <Iconify className="text-amber-600 dark:text-amber-400 flex-shrink-0" width={13} icon="fluent:note-16-filled" />
                  <span className="text-[11px] font-semibold text-amber-800 dark:text-amber-300 truncate">
                    {message.userName}
                  </span>
                </div>

                <Button
                  onClick={onDeleteNote}
                  size="icon"
                  variant="ghost"
                  className="h-5 w-5 rounded-md text-amber-700/60 hover:text-red-500 hover:bg-amber-200/50 dark:text-amber-400/60 dark:hover:bg-amber-500/20 opacity-0 group-hover/nota:opacity-100 transition-opacity"
                >
                  <Iconify width={13} icon="mi:delete" />
                </Button>
              </div>

              <div className="px-3 py-2 text-[13px] leading-relaxed text-amber-900 dark:text-amber-100 whitespace-pre-wrap break-words">
                <div ref={textRef}>{message.body}</div>
              </div>

              <div className="flex justify-end px-2.5 pb-1.5 -mt-1">
                {getMessageTime(message)}
              </div>
            </div>
          </Stack>
        </ChatLayout>
      </Stack>
    )
  }

  if (message.ack === -1) {
    return (
      <div className="w-full flex justify-end mt-6">
        <div className="flex flex-row items-center gap-2 max-w-[800px]">
          <div className="flex flex-row gap-1">
            <ZuiTooltip content={t('messageList.actions.resend', { defaultValue: 'Reenviar' })}>
              <Button
                size="icon"
                onClick={handleResendClick}
                variant="outline"
                disabled={isButtonDisabled || loadingResend || loadingResendAudio}
                className="h-8 w-8 rounded-full border-violet-200 dark:border-violet-500/30 text-violet-600 dark:text-violet-300 hover:bg-violet-50 dark:hover:bg-violet-500/10"
              >
                {(loadingResend || loadingResendAudio) ? (
                  <Iconify icon="svg-spinners:ring-resize" width={15} />
                ) : (
                  <Iconify icon="stash:arrow-retry" width={17} />
                )}
              </Button>
            </ZuiTooltip>

            <Button
              size="icon"
              onClick={() => onDeleteMsgAudioResend(message)}
              variant="outline"
              className="h-8 w-8 rounded-full border-red-200 dark:border-red-500/30 text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10"
            >
              <Iconify icon="material-symbols:delete" width={15} />
            </Button>
          </div>

          <Card className="flex flex-col px-3 py-2 rounded-2xl rounded-tr-[4px] bg-red-50 dark:bg-red-500/10 border border-red-200/80 dark:border-red-500/20 shadow-sm dark:shadow-none">
            {(message.type === 'audio' || message.type === 'ptt') ? (
              <div>
                <AudioComponent
                  downloaded={true}
                  url={audioUrl}
                  loading={false}
                  isMe={message.fromMe}
                  remoteSource={!!message.isMetaMedia}
                  profileImage={!message?.sender?.profilePicThumbObj?.eurl ? defaultImage : message?.sender?.profilePicThumbObj?.eurl}
                  audioRef={audioRef}
                  id={message.id}
                  getAudioFromCache={getAudioFromCache}
                />
              </div>
            ) : message.template ? (
              <div className="flex relative py-2 whitespace-pre-wrap text-[13.5px]">
                <TemplateMessage
                  template={message.template}
                  isMe={isMe}
                  positions={message?.template?.positions || []}
                />
              </div>
            ) : (
              <div className="flex relative py-2 whitespace-pre-wrap text-[13.5px]" isWarning={isWarning}>
                <div ref={textRef}>{getBodyMessage()}</div>
              </div>
            )}
            <div className="flex justify-end pt-0.5">
              {getMessageTime(message)}
            </div>
            {message.errorMessage && (
              <div className="flex items-start gap-1.5 mt-1 px-1.5 py-1 bg-red-100 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 rounded-lg text-xs text-red-700 dark:text-red-400">
                <Iconify icon="solar:danger-triangle-bold" className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                <div>
                  <span className="font-medium">{t('common:status.error')} {message.errorMessage.code}: </span>
                  <span>{message.errorMessage.message}</span>
                </div>
              </div>
            )}
          </Card>


        </div>

      </div>

    )
  }

  return (
    <Stack key={key} direction={'row'}>
      <ChatLayout side={isMe}>

        <Stack sx={{ mt: 3 }}>
          <div className={`flex items-start gap-1 ${isMe === 'left' ? 'flex-row' : 'flex-row-reverse'} group`}>
            <Tooltip
              title={message.fromMe === false ? getSenderDisplayName() : ''}
              placement="top"
              arrow
            >
            <div
              className={`${isDesktop ? 'w-fit' : 'w-full'} text-xs max-w-full h-auto relative flex flex-col flex-wrap min-w-[76px] text-gray-800 dark:text-[#D1D2D3] ${isWarning
                ? 'w-full text-center'
                : `shadow-sm dark:shadow-none rounded-2xl ${isMe === "left"
                  ? 'rounded-tl-[4px] bg-white dark:bg-[#222529]'
                  : 'rounded-tr-[4px] bg-[#d9fdd3] dark:bg-[#005C4B]'}`
                } p-1.5`}
            >
              {/* Origem Click-to-WhatsApp: a Meta manda o bloco `referral` na
                  primeira mensagem de quem clicou no anuncio/publicacao. */}
              {!!message.referral && !message.isDeleted && (
                <ReferralCard referral={message.referral} />
              )}

              {/* Instagram: o cliente mencionou a conta em um story dele (nao e
                  resposta a story nosso — isso e a QuotedMessage.isStory logo abaixo).
                  O `type` original da Meta (story_mention) nunca chega aqui: o balao ja
                  renderiza como video/imagem normal, entao sem este rotulo fica
                  indistinguivel de um envio comum. */}
              {!!message.isStoryMention && !message.isDeleted && (
                <div className="flex items-center gap-1 px-1 pb-1 text-[11px] text-gray-400 dark:text-neutral-500">
                  <Iconify icon="mdi:instagram" width={12} />
                  <span>{t('storyMention.label', 'Mencionou você em um story')}</span>
                </div>
              )}

              <MessageContent sx={{ elevation: 0 }} side={isMe} isWarning={isWarning}>
                {message.isDeleted ? (
                  <MessageContentText isWarning={isWarning}>
                    <div ref={textRef}>{getBodyMessage()}</div>
                  </MessageContentText>
                ) : message.type === "document" ? (
                  message.preSend ? (
                    <SendingPlaceholder icon="solar:document-bold" label={t('media.sendingDocument')} />
                  ) : (
                    <div
                      className={`flex items-center gap-2.5 w-[260px] max-w-full rounded-xl border cursor-pointer px-2.5 py-2 transition-colors bg-white/60 dark:bg-white/[0.04] border-black/5 dark:border-white/10 hover:bg-white dark:hover:bg-white/[0.08] ${isWarning ? 'w-full max-w-lg' : ''}`}
                      onClick={() =>
                        onClickDownload("document", {
                          mimetype: message.mimetype,
                          filename: message.filename,
                          mediadata: message.mediadata,
                        })
                      }
                    >
                      <div className="w-9 h-9 rounded-lg bg-violet-100 dark:bg-violet-500/20 flex items-center justify-center flex-shrink-0">
                        <Iconify icon="solar:document-bold" width={18} className="text-violet-600 dark:text-violet-300" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-[13px] font-medium truncate text-gray-800 dark:text-neutral-100">
                          {message.filename}
                        </p>
                        <p className="text-[10px] uppercase tracking-wider text-gray-400 dark:text-neutral-500">
                          {message.filename?.includes('.') ? message.filename.split('.').pop().slice(0, 6) : 'doc'}
                        </p>
                      </div>
                      <div className="flex-shrink-0">
                        {loadingDownload ? (
                          <Iconify icon="svg-spinners:ring-resize" width={16} className="text-violet-500 mr-1.5" />
                        ) : (
                          <ButtonLoading
                            variant="ghost"
                            size="icon"
                            className="w-7 h-7 rounded-full hover:bg-violet-50 dark:hover:bg-violet-500/10"
                          >
                            <Iconify icon="solar:download-bold" width={14} className="text-violet-600 dark:text-violet-300" />
                          </ButtonLoading>
                        )}
                      </div>
                    </div>
                  )
                ) : message.type === "vcard" ? (
                  <MessageContentText >
                    <Vcard
                      message={message}
                    />
                  </MessageContentText>
                ) : message.type === "multi_vcard" ? (
                  <MessageContentText >
                    <ModalMultiContact
                      message={message}
                    />

                  </MessageContentText>
                ) : message.type === "e2e_notification" ? (
                  <MessageContentText >
                    <Alert variant="outlined" severity="info">{t('messageList.encryptionMessage')}</Alert>
                  </MessageContentText>
                ) : message.type === "notification_template" ? (
                  <MessageContentText >
                    <Alert variant="outlined" severity="info">{t('messageList.whatsappMessage')}</Alert>
                  </MessageContentText>
                ) : message.type === "protocol" ? (
                  <MessageContentText >
                    <Alert variant="outlined" severity="info">{t('messageList.whatsappMessage')}</Alert>
                  </MessageContentText>
                ) : message.type === "call_log" ? (
                  <MessageContentText >
                    <Alert variant="outlined" severity="error">{t('messageList.missedCall')}</Alert>
                  </MessageContentText>
                ) : message.template ? (
                  <MessageContentText >
                    <TemplateMessage
                      template={message.template}
                      isMe={isMe}
                      positions={message?.template?.positions || []}
                    />
                  </MessageContentText>
                ) : (
                  <MessageContentText isWarning={isWarning}>
                    {!!message.quotedMsg && <QuotedMessage message={message} />}
                    <div ref={textRef}>{getBodyMessage()}</div>
                  </MessageContentText>
                )}
              </MessageContent>

              {message.caption && !message.isDeleted && (
                <span className="px-1.5 pt-1 text-[13px] leading-snug whitespace-pre-wrap break-words">
                  {message.caption}
                </span>
              )}

              {/* Hora + status dentro do balao (padrao WhatsApp) — a linha externa
                  ficou reservada para excecoes (apagada/erro). */}
              <div className={`flex items-center gap-1 px-1 pb-0.5 mt-0.5 ${isWarning ? 'justify-center' : 'justify-end'}`}>
                {message.isDeleted && (
                  <Tooltip title={t('messageList.messageDeleted')}>
                    <span className="inline-flex">
                      <Iconify width={13} icon="material-symbols:delete" className="text-red-500" />
                    </span>
                  </Tooltip>
                )}
                {getMessageTime(message)}
              </div>

            </div>
            </Tooltip>

            {!isReply && (
              <div className="opacity-0 group-hover:opacity-100 transition-all duration-200 ease-in-out self-center scale-75 group-hover:scale-100 px-1">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button
                      className="w-7 h-7 rounded-full bg-white dark:bg-[#222529] shadow-sm hover:shadow-md dark:shadow-none border border-gray-100 dark:border-[#383838] text-gray-500 dark:text-[#D1D2D3] hover:text-gray-800 hover:bg-gray-50 dark:hover:bg-[#2a2d31] transition-all"
                      size="icon"
                    >
                      <Iconify icon="tabler:dots-vertical" className="w-4 h-4" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="w-48" align={isMe === 'left' ? 'start' : 'end'}>
                    {!typesIgnore.includes(message.type) && options.map((option) => (
                      <DropdownMenuItem key={option.label} onClick={() => option.method()}>
                        {option.label}
                      </DropdownMenuItem>
                    ))}

                    {message.type === "chat" && verifyRules(user.rules, 'chatgpt') && (
                      <>
                        <Divider />
                        <DropdownMenuSub>
                          <DropdownMenuSubTrigger>{t('copilot.title', 'Copilot')}</DropdownMenuSubTrigger>
                          <DropdownMenuPortal>
                            <DropdownMenuSubContent className="w-[300px] mb-16">
                              <Scrollbar>
                                {gatilhosCopilot?.length > 0 && gatilhosCopilot.map(gatilho => {
                                  return (
                                    <DropdownMenuItem
                                      key={gatilho.nome}
                                      onClick={() => {
                                        let data = {
                                          message: message.body,
                                          input: gatilho.input
                                        }

                                        callbackGpt(data);
                                        handleCloseMenu()
                                        handleClose();

                                      }}>
                                      <Stack alignItems={"center"} spacing={1} direction={"row"}>
                                        {gatilho.nome}
                                      </Stack>

                                    </DropdownMenuItem>
                                  )
                                })}
                              </Scrollbar>
                            </DropdownMenuSubContent>
                          </DropdownMenuPortal>
                        </DropdownMenuSub>
                      </>
                    )}
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            )}
          </div>
          {message.errorMessage && (
            <Stack direction={"row"} justifyContent={isMe === 'right' ? 'flex-end' : 'flex-start'}>
              <div className="flex items-start gap-1.5 mt-1 px-1.5 py-1 bg-red-100 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 rounded-lg text-xs text-red-700 dark:text-red-400 max-w-[400px]">
                <Iconify icon="solar:danger-triangle-bold" className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                <div>
                  <span className="font-medium">{t('common:status.error')} {message.errorMessage.code}: </span>
                  <span>{message.errorMessage.message}</span>
                </div>
              </div>
            </Stack>
          )}
        </Stack>


        {openDeleteDialog && (
          <AlertDialogLoading
            loading={loadingDeletarMensagem}
            title={t('messageList.confirmDeleteTitle')}
            content={t('messageList.confirmDeleteContent')}
            confirm={async () => {
              try {
                setLoadingDeletarMensagem(true);
                await excluirMensagem(message);
              } catch (error) {
                enqueueSnackbar(t('messageList.deleteFailed'), { variant: 'error' });

              } finally {
                setOpenDeleteDialog(false);
                setLoadingDeletarMensagem(false);
              }
            }}
            close={() => setOpenDeleteDialog(false)}
          />
        )}

        {openEncaminharDialog && (
          <ModalEncaminharMsg
            user={user}
            open={openEncaminharDialog}
            loading={loadingEncaminharMensagem}
            onSubmit={data => {
              encaminharMesagemWhatsapp(data);
            }}
            onClose={() => setOpenEncaminharDialog(false)}
          />
        )}
      </ChatLayout>
    </Stack>

  );
};

ChatComponent.propTypes = {
  message: PropTypes.any.isRequired,
  session: PropTypes.string.isRequired,
  isMe: PropTypes.string.isRequired,
};

export default ChatComponent;
